
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOnOffIec as ObiOnOffIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-on-off-iec.js';
 
 
 

 
 export const ObiOnOffIec = createComponent({
   react: React,
   tagName: 'obi-on-off-iec',
   elementClass: ObiOnOffIecElement,
   events: {
     
   }
  });
 
 